export function Footer() {
  return (
    <>
      <a href={`${Homepage}/LICENCE`} target="_blank">MIT LICENCE</a>
      <span>
        <span>NewsNow © 2024 </span>
        
      </span>
    </>
  )
}
